<template>
  <!--
    O overlay cobre a tela inteira enquanto carrega. Sem `role="status"` +
    `aria-live="polite"` nada era anunciado: a tela simplesmente travava e quem usa
    leitor de tela não tinha como saber por quê. `aria-busy` marca a região como em
    transição.

    Os quadradinhos são decoração pura, então saem da árvore de acessibilidade e só o
    texto "Carregando..." é lido.
  -->
  <div class="offcanvas-backdrop fade show" style="opacity:0.8" role="status" aria-live="polite"
    aria-busy="true">
    <div class="loader">
      <div class="square" aria-hidden="true"></div>
      <div class="square" aria-hidden="true"></div>
      <div class="square last" aria-hidden="true"></div>
      <div class="square clear" aria-hidden="true"></div>
      <div class="square" aria-hidden="true"></div>
      <div class="square last" aria-hidden="true"></div>
      <div class="square clear" aria-hidden="true"></div>
      <div class="square " aria-hidden="true"></div>
      <div class="square last" aria-hidden="true"></div>
      <div class="row loading-text" style="display:block">
        <!-- <p> e não <h6>: não é cabeçalho de seção. Como <h6>, cada carregamento
             injetava um "Carregando..." solto na lista de cabeçalhos do leitor de tela
             (e no painel "Estrutura da Página" do widget de acessibilidade). -->
        <p class="h6 mb-0">Carregando...</p>
      </div>
    </div>

  </div>
</template>
  
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "LoaderFullScreen",
  methods: {},
});
</script>
<style lang="scss">
$squarew: 15px;
$squareh: 15px;
$squaremargin: 5px;
$loaderw: $squarew * 3 + $squaremargin *2;
$loaderh: $squareh * 3 + $squaremargin *2;
$delayenter: 0.2s;
$topenter: -10px;

@mixin transition($value) {
  -webkit-transition: $value ;
  -moz-transition: $value ;
  transition: $value ;
}

@mixin delay($delay ) {
  -webkit-animation-delay: $delay;
  -moz-animation-delay: $delay;
  animation-delay: $delay;
}

@-webkit-keyframes enter {
  0% {
    opacity: 0;
    top: $topenter;
  }

  5% {
    opacity: 1;
    top: 0px;
  }

  50.9% {
    opacity: 1;
    top: 0px;
  }

  55.9% {
    opacity: 0;
    top: - $topenter;
  }
}

@keyframes enter {
  0% {
    opacity: 0;
    top: $topenter;
  }

  5% {
    opacity: 1;
    top: 0px;
  }

  50.9% {
    opacity: 1;
    top: 0px;
  }

  55.9% {
    opacity: 0;
    top: - $topenter;
  }
}

@-moz-keyframes enter {
  0% {
    opacity: 0;
    top: $topenter;
  }

  5% {
    opacity: 1;
    top: 0px;
  }

  50.9% {
    opacity: 1;
    top: 0px;
  }

  55.9% {
    opacity: 0;
    top: - $topenter;
  }
}

/*
 * REMOVIDOS: `body { background: #1fbeca }` e `* { margin: 0 }`.
 *
 * Este componente é registrado globalmente no `main.ts`, e o bloco <style> não era
 * scoped — as duas regras valiam para o sistema inteiro desde o carregamento da
 * aplicação. O ciano nunca foi o fundo do loader: o overlay dele é a própria
 * `.offcanvas-backdrop` do template. E `* { margin: 0 }` é um reset global escrito dentro
 * de um componente de carregamento, num projeto que já usa o reboot do Bootstrap.
 *
 * O risco não é teórico: um `body { background }` inesperado altera o fundo sobre o qual
 * TODO texto do sistema é medido, e é o tipo de regra que faz uma auditoria de contraste
 * dar resultados diferentes conforme o que foi carregado antes (WCAG 1.4.3 / 1.4.6).
 *
 * Registrado como pendência havia tempo em docs/acessibilidade; a verificação de que o
 * ciano era vestigial é o que permitiu remover com segurança.
 */

.loader {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: calc((-1*$loaderw) / 2);
  margin-top: calc((-1*$loaderh) / 2);
  z-index: 999999999999;

}

.square {
  background: white;
  width: $squarew;
  height: $squareh;
  float: left;
  top: $topenter;
  margin-right: $squaremargin;
  margin-top: $squaremargin;
  position: relative;
  opacity: 0;
  -webkit-animation: enter 6s infinite;
  animation: enter 4s infinite;
}

.enter {
  top: 0px;
  opacity: 1;
}

.square:nth-child(1) {
  @include delay(6 * $delayenter);
}

.square:nth-child(2) {
  @include delay(7 * $delayenter);
}

.square:nth-child(3) {
  @include delay(8 * $delayenter);
  background: #fdc96f;
}

.square:nth-child(4) {
  @include delay(3 * $delayenter);
}

.square:nth-child(5) {
  @include delay(4 * $delayenter);
}

.square:nth-child(6) {
  @include delay(5 * $delayenter);
}


.square:nth-child(8) {
  @include delay(1 * $delayenter);
}

.square:nth-child(9) {
  @include delay(2 * $delayenter);
}

.clear {
  clear: both;
}

.last {
  margin-right: 0;
}
.loading-text{
  display: block;
  color: white;
  font-weight: bolder;
}
</style>